import { render, staticRenderFns } from "./comment-manage.vue?vue&type=template&id=9db22ad2&scoped=true&"
import script from "./comment-manage.vue?vue&type=script&lang=js&"
export * from "./comment-manage.vue?vue&type=script&lang=js&"
import style0 from "./comment-manage.vue?vue&type=style&index=0&id=9db22ad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db22ad2",
  null
  
)

export default component.exports